import { Avatar } from "@material-tailwind/react";
import React from "react";
import NoDataImage from "../../Assets/Images/NoData.jpg";
import NoDebateImage from "../../Assets/Images/NoDebate.png";
import BasicButton from "../UI/Buttons/BasicButton";

// Create context for NoData
const NoDataContext = React.createContext({
  message: undefined,
  handleClick: undefined,
  greet: undefined,
});

// NoData component
const NoData = ({
  isUserLoading = false,
  message,
  greet,
  children,
  isNoData = false,
  size,
  containerClass,
}) => {
  const defaultSetting = "flex w-full flex-col h-full px-3 md:px-8 py-4 justify-center items-center overflow-y-auto"
  return (
    <NoDataContext.Provider value={{ message, greet }}>
      <div className={containerClass ? containerClass : defaultSetting}>
        <div
          className={`flex flex-col gap-2 justify-center items-center rounded-md relative px-10 ${
            size ? size : "h-full w-full"
          }`}
        >
          <Avatar
            variant="rounded"
            src={isNoData ? NoDataImage : NoDebateImage}
            alt="NoData"
            className={`${
              isNoData
                ? "md:min-h-full md:min-w-full"
                : "min-h-full min-w-full"
            } object-contain`}
          />
          {isUserLoading ? (
            <p
              className={`text-secondary text-xl font-bold animate__fadeIn w-20`}
            ></p>
          ) : (
            greet && <p className={`text-secondary text-xl font-bold`}>{greet}</p>
          )}
          <p className="text-secondary text-xl font-bold">{message}</p>
          {children}
        </div>
      </div>
    </NoDataContext.Provider>
  );
};

export default NoData;

// NoData.Buttons component
NoData.Buttons = function NoDataButtons({ btn, handleClick, disable = false }) {
  return (
    <div className="flex gap-2">
      <BasicButton
        color="secondary"
        isDisable={disable}
        className="px-4 my-1.5 text-md capitalize"
        onClick={handleClick}
      >
        {btn}
      </BasicButton>
    </div>
  );
};
